function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import { List, Modal, Space, notification } from "antd";
import { PencilSquare, TrashFill, TelephoneFill } from "react-bootstrap-icons";
import Common from "./includes/Common";
import EditIntructor from "./forms/EditInstructor";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var InsctructorsList = function InsctructorsList(_ref) {
  var _ref$list = _ref.list,
    list = _ref$list === void 0 ? [] : _ref$list,
    refresh = _ref.refresh;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    selectedInstructor = _useState2[0],
    setSelectedInstructor = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showEdit = _useState4[0],
    setShowEdit = _useState4[1];
  var _useState5 = useState(list),
    _useState6 = _slicedToArray(_useState5, 2),
    iList = _useState6[0],
    setIList = _useState6[1];
  var handleDelete = function handleDelete(i) {
    setSelectedInstructor(i);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez - vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["La suppression de l'instructeur ", i.name]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "deleteinstructor").then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Ok !",
              description: "Opération réussie !"
            });
          } else {
            notification.error({
              message: "Echec !",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Echec !",
            description: "Une erreur est survenue"
          });
        })["finally"](function () {});
      }
    });
  };
  useEffect(function () {
    setIList(list);
  }, [list]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(List, {
      itemLayout: "horizontal",
      dataSource: iList,
      renderItem: function renderItem(item) {
        return /*#__PURE__*/_jsxs(List.Item, {
          actions: [/*#__PURE__*/_jsx("a", {
            onClick: function onClick() {
              setSelectedInstructor(item);
              setShowEdit(true);
            },
            children: /*#__PURE__*/_jsx(PencilSquare, {
              size: 24
            })
          }), /*#__PURE__*/_jsx("a", {
            onClick: function onClick() {
              handleDelete(item);
            },
            children: /*#__PURE__*/_jsx(TrashFill, {
              size: 24
            })
          })],
          children: [/*#__PURE__*/_jsx(List.Item.Meta, {
            title: /*#__PURE__*/_jsx("b", {
              children: "".concat(item.prenom, " ").concat(item.nom)
            }),
            description: /*#__PURE__*/_jsxs(Space, {
              direction: "horizontal",
              children: [/*#__PURE__*/_jsx("span", {
                children: item.skills
              }), /*#__PURE__*/_jsxs("span", {
                children: [/*#__PURE__*/_jsx(TelephoneFill, {
                  size: 24
                }), " ", item.mobile]
              })]
            })
          }), /*#__PURE__*/_jsx("div", {})]
        });
      }
    }), selectedInstructor != null && /*#__PURE__*/_jsx(Modal, {
      title: /*#__PURE__*/_jsx("b", {
        children: "MODIFIER"
      }),
      width: "500px",
      open: showEdit,
      onCancel: function onCancel() {
        setShowEdit(false);
      },
      footer: null,
      destroyOnClose: true,
      children: /*#__PURE__*/_jsx(EditIntructor, {
        instructor: selectedInstructor,
        handler: refresh
      })
    })]
  });
};
export default InsctructorsList;